import { render, staticRenderFns } from "./AnnotationExportModal.vue?vue&type=template&id=47872798&scoped=true&"
import script from "./AnnotationExportModal.vue?vue&type=script&lang=js&"
export * from "./AnnotationExportModal.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationExportModal.vue?vue&type=style&index=0&id=47872798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47872798",
  null
  
)

export default component.exports